import type { MoodType } from "./FeedbackDrawer";

export const isSelectedMood = (mood: MoodType, selectedMood: MoodType | undefined) => {
  return mood === selectedMood;
};
